import {LoyaltyCardModel} from '../../core-logic/models/loyalty-card/loyalty-card-model';
import {BehaviorSubject, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {StorageManagerGatewayCapacitor} from '../../adapters/real/app-services/storage-manager-gateway-capacitor';

@Injectable({
  providedIn: 'root'
})
export class StorageLoyaltiesCardsManagerService {
  private idLoyaltyCardsAndLoyaltyCardsMap: Map<string, LoyaltyCardModel> = new Map<string, LoyaltyCardModel>();
  private loyaltiesCardsSubject$: BehaviorSubject<Map<string, LoyaltyCardModel>> =
      new BehaviorSubject<Map<string, LoyaltyCardModel>>(this.idLoyaltyCardsAndLoyaltyCardsMap);
  private idOfLastChangedLoyaltyCardSubject$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  constructor(private storageManager: StorageManagerGatewayCapacitor) {}

  init() {
    this.storageManager.getCurrentUser()
      .subscribe(currentUser => {
        this.initIdLoyaltyCardsAndLoyaltyCardsMap(currentUser.loyalty_cards);
        this.emitLoyaltiesCardsMap(this.idLoyaltyCardsAndLoyaltyCardsMap);
      });
  }

  add(loyaltyCardModel: LoyaltyCardModel) {
    this.idLoyaltyCardsAndLoyaltyCardsMap.set(loyaltyCardModel._id, loyaltyCardModel);
    this.emitLoyaltiesCardsMap(this.idLoyaltyCardsAndLoyaltyCardsMap);
    this.emitIdOfLastChangedLoyaltyCard(loyaltyCardModel._id);
  }

  getLoyaltyCard(loyaltyCardId: string): LoyaltyCardModel {
    return this.idLoyaltyCardsAndLoyaltyCardsMap.get(loyaltyCardId);
  }

  getLoyaltiesCardsSubject$(): Observable<Map<string, LoyaltyCardModel>> {
    return this.loyaltiesCardsSubject$;
  }

  getIdOfLastUpdatedLoyaltyCardSubject$(): Observable<string> {
    return this.idOfLastChangedLoyaltyCardSubject$;
  }

  unsetIdOfLastUpdatedLoyaltyCardSubject$() {
    this.emitIdOfLastChangedLoyaltyCard('');
  }

  private initIdLoyaltyCardsAndLoyaltyCardsMap(loyaltyCardModels: LoyaltyCardModel[]) {
    loyaltyCardModels.forEach(loyaltyCardModel => {
      this.idLoyaltyCardsAndLoyaltyCardsMap.set(loyaltyCardModel._id, loyaltyCardModel);
    });
  }

  private unsetLoyaltiesCardsSubject$() {
    this.idLoyaltyCardsAndLoyaltyCardsMap.clear();
    this.emitLoyaltiesCardsMap(this.idLoyaltyCardsAndLoyaltyCardsMap);
  }

  private emitLoyaltiesCardsMap(idLoyaltyCardsAndLoyaltyCardsMap: Map<string, LoyaltyCardModel>) {
    this.loyaltiesCardsSubject$.next(idLoyaltyCardsAndLoyaltyCardsMap);
  }

  emitIdOfLastChangedLoyaltyCard(loyaltyCardId: string) {
    this.idOfLastChangedLoyaltyCardSubject$.next(loyaltyCardId);
  }

  reset() {
    this.unsetIdOfLastUpdatedLoyaltyCardSubject$();
    this.unsetLoyaltiesCardsSubject$();
  }
}
